import { css, DefaultTheme } from 'styled-components';

export type BreakpointDirection = 'up' | 'down' | 'only' | undefined;

export const getMediaQuery = (
  theme: DefaultTheme,
  breakpoint: string,
  breakpointDirection: BreakpointDirection = undefined
) => {
  const breakpoints = theme.grid.breakpoints;
  const breakpointValue: string = breakpoints[breakpoint];

  if (!breakpointDirection || breakpointDirection == 'up') {
    return `@media screen and (min-width: ${breakpointValue})`;
  }

  const breakpointKeys = Object.keys(breakpoints);

  const nextBreakpointIndex = breakpointKeys.indexOf(breakpoint) + 1;
  const nextBreakpoint =
    nextBreakpointIndex < breakpointKeys.length
      ? breakpointKeys[nextBreakpointIndex]
      : null;
  const nextBreakpointValue: number | undefined = nextBreakpoint
    ? theme.grid.breakpointValues[nextBreakpoint]
    : null;

  switch (breakpointDirection) {
    default:
      return `@media screen and (min-width: ${breakpointValue})`;

    case 'down':
      if (nextBreakpointValue) {
        return `@media screen and (max-width: ${nextBreakpointValue - 1}px)`;
      }
      return `@media screen and (min-width: 0px)`;

    case 'only':
      if (nextBreakpointValue) {
        return `@media screen and (min-width: ${breakpointValue}) and (max-width: ${
          nextBreakpointValue - 1
        }px)`;
      }
      return `@media screen and (min-width: ${breakpointValue})`;
  }
};

export const breakpoint = (
  breakpoint: string,
  breakpointDirection: BreakpointDirection = undefined
) => css`
  ${(p) => getMediaQuery(p.theme, breakpoint, breakpointDirection)}
`;
